import axios from "axios";
import { BaseResponseSingle, BaseResponse } from "../../typings";
import { 
  IStoreClosureDateResponse, 
  IStoreClosureDateRequest 
} from "../../typings/interfaces/responses/store-closure-date-response";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  GET_STORE_CLOSURE_DATES, 
  ADD_STORE_CLOSURE_DATE, 
  UPDATE_STORE_CLOSURE_DATE, 
  DELETE_STORE_CLOSURE_DATE 
} from "../../configs";

export const getStoreClosureDates = createAsyncThunk(
  "store-closure-date/getAll",
  async (
    { storeId, merchantId }: { storeId: number; merchantId: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.get<
        BaseResponse<IStoreClosureDateResponse>
      >(GET_STORE_CLOSURE_DATES(storeId, merchantId));
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const addStoreClosureDate = createAsyncThunk(
  "store-closure-date/add",
  async (
    data: IStoreClosureDateRequest,
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post<
        BaseResponseSingle<IStoreClosureDateResponse>
      >(ADD_STORE_CLOSURE_DATE, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const updateStoreClosureDate = createAsyncThunk(
  "store-closure-date/update",
  async (
    { id, data }: { id: number; data: IStoreClosureDateRequest },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put<
        BaseResponseSingle<IStoreClosureDateResponse>
      >(UPDATE_STORE_CLOSURE_DATE(id), data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const deleteStoreClosureDate = createAsyncThunk(
  "store-closure-date/delete",
  async (
    id: number,
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.delete<
        BaseResponseSingle<boolean>
      >(DELETE_STORE_CLOSURE_DATE(id));
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

